import { Component, Input } from "@angular/core";
import { NbButtonModule, NbCardModule, NbDialogRef } from "@nebular/theme";
import { MatterportPageComponent } from "../matterport-page/matterport-page.component";
import { TimeSelectorComponent } from "../time-selector/time-selector.component";

@Component({
  selector: "ngx-matterport-viewer-popup",
  templateUrl: "./matterport-viewer-popup.component.html",
  styleUrls: ["./matterport-viewer-popup.component.scss"],
  imports: [
    NbCardModule,
    MatterportPageComponent,
    NbButtonModule,
    TimeSelectorComponent,
  ],
})
export class MatterportViewerPopupComponent {
  @Input() public matterportModelSid: string;
  @Input() public matterportAssetName: string;

  public constructor(private ref: NbDialogRef<any>) {}

  public close(): void {
    this.ref.close();
  }
}
